// Store de dashboard — dados resumidos para as telas index.vue e index2.vue
import { apiGet } from '@/api/conserv';

// ---- Dashboard pregões (index.vue) ----

export async function listaPregoesDash() {
    return apiGet('api/DashPregoes/ListaPregoesDash');
}

export async function contaAlertas7Dias() {
    return apiGet('api/DashPregoes/ContaAlertas7Dias');
}

export async function listaUltimosCad() {
    return apiGet('api/DashPregoes/ListaUltimosCad');
}

export async function listaTop10Alertas() {
    return apiGet('api/DashPregoes/ListaTop10Alertas');
}

export async function pegaTotaisItens(filtro = 'andamento') {
    return apiGet(`api/DashPregoes/PegaTotaisItens?filtro=${filtro}`);
}

export async function produtoMaisVendido(filtro = 'andamento') {
    return apiGet(`api/DashPregoes/ProdutoMaisVendido?filtro=${filtro}`);
}

export async function topProdutos(filtro = 'andamento', top = 10) {
    return apiGet(`api/DashPregoes/TopProdutos?filtro=${filtro}&top=${top}`);
}

export async function pega5ConcsWinFatu() {
    return apiGet('api/DashPregoes/Pega5ConcsWinFatu');
}

export async function pegaLucro7Dias(filtro = 'andamento') {
    return apiGet(`api/DashPregoes/PegaLucro7Dias?filtro=${filtro}`);
}

export async function topProdutosTodos(top = 10) {
    return apiGet(`api/DashPregoes/TopProdutosTodos?top=${top}`);
}

// ---- Dashboard licitações (index2.vue) ----

export async function listaLics24H() {
    return apiGet('api/DashLics/ListaLics24H');
}

export async function listaUltimasLics() {
    return apiGet('api/DashLics/ListaUltimasLics');
}
